import { CalendarManager, IPOs, ISetParams } from '@benzinga/calendar-manager';
import { Session } from '@benzinga/session';
import { injectLogos } from '../lib/utils';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchIPO = (
  session: Session,
  params: ISetParams = {},
  injectTickersLogos = true,
  pageSize = 100,
): Promise<IPOs[]> => {
  return session
    .getManager(CalendarManager)
    .getCalendarData('ipos', { ...params, pageSize })
    .then(res => {
      if (res.ok && res.ok.length) {
        return injectTickersLogos ? injectLogos(res.ok) : res.ok;
      }
      return [];
    })
    .catch(error => {
      logCalendarFetchFailure('ipos', error);
      return [];
    });
};

export { fetchIPO };
